import classNames from 'classnames';

export interface ToggleProps {
  onChange?: (event) => void;
  checked?: boolean;
  disabled?: boolean;
  name?: string;
  testId?: string;
}

export const PositionedToggle = ({
  onChange,
  checked,
  disabled,
  name = 'toggle',
  testId,
}: ToggleProps) => {
  return (
    <div>
      <label
        className={classNames(
          'relative w-full',
          disabled ? 'cursor-default' : 'cursor-pointer'
        )}
      >
        <input
          type="checkbox"
          name={name}
          className="hidden"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          data-testid={testId}
        />
        <div
          className={classNames(
            'absolute m-0.5 inset-0 w-2 h-2 rounded-full bg-ds-accent3-100 z-20 duration-300 ease-in-out'
          )}
          style={{
            transform: `translateX(${checked ? '14px' : '0'})`,
          }}
        />
        <div
          className={classNames(
            'w-ds-26 h-3 rounded-full z-0 transition-colors transform duration-200',
            {
              'bg-ds-natural-150': !checked && disabled,
              'bg-ds-primary-300 opacity-70': checked && disabled,
              'active:bg-gradient-to-r active:from-ds-primary-500 active:to-ds-natural-200':
                !disabled,
              'hover:bg-ds-primary-400 bg-ds-primary': checked && !disabled,
              'bg-ds-natural-300 hover:bg-ds-natural-400':
                !checked && !disabled,
            }
          )}
        />
      </label>
    </div>
  );
};
